// extracted by mini-css-extract-plugin
export default {"icon":"new_icon__xFaLS","box1":"new_box1__-SCeq","heading1":"new_heading1__LVmuM","listbtn":"new_listbtn__PUxx8","unlist":"new_unlist__UL6+F"};